export const FILTER_DRAWER_OPERATIONS_TEST_ID = {
    FIELD: 'campaigns-filter-field',
    OPERATOR: 'campaigns-filter-operator',
    VALUE: 'campaigns-filter-value',
    APPLY: 'campaigns-filter-apply',
};

export const FILTER_DRAWER_OPERATIONS_TEXTS = {
    FIELD: 'Filter',
    OPERATOR: 'Type',
    VALUE: 'Value',
    APPLY: 'Apply filter',
};

export const FILTER_DRAWER_OPERATIONS_AUTO_TEST_ID = {
    FIELD: 'campaigns-filter-field',
    OPERATOR: 'campaigns-filter-operator',
    VALUE: 'campaigns-filter-value',
    APPLY: 'campaigns-filter-apply',
};
